<template>
  <section
    v-if="list && list.length > 0"
    class="video-model"
  >
    <h3>电影</h3>
    <ul class="video-model-list three">
      <li
        v-for="(item, index) in list"
        v-show="show(index)"
        :key="index"
      >
        <a
          :href="item.playurl"
          uigs="out_home_list_top_pic_movie"
        >
          <div class="video-model-img-v">
            <img-item
              :src="item.picurl"
              :lazy="!show(index)"
            />
            <span
              v-if="item.fee === '1'"
              class="tag-fee"
            >VIP</span>
            <span class="tag-mark">{{ item.score && item.score.length === 1 ? item.score + '.0' : item.score }}</span>
          </div>
          <p class="video-model-title">{{ item.name }}</p>
        </a>
      </li>
    </ul>
    <div class="video-model-btn">
      <a
        href="/list?listTab=film"
        uigs="out_home_list_bottom_film"
      ><span class="more">查看更多</span></a>
      <a
        uigs="home_film_list_change"
        @click="change"
      ><span class="change">换一换</span></a>
    </div>
  </section>
</template>

<script>
import ImgItem from './ImgItem';

export default {
  components: {
    ImgItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      num: 6,
      start: 0,
    };
  },
  methods: {
    show(index) {
      if (index >= this.start && index < this.start + this.num) {
        return true;
      }
      return false;
    },
    change() {
      const start = this.start + this.num;
      this.start = start >= this.list.length ? 0 : start;
    },
  },
};
</script>
